import { MultiSelectSearchListWithLinks } from 'components/helpers/CustomFieldRenderers/SearchListFieldRenderer/MultiSelectSearchListWithLinks';
import { EditSingleSelectRadio } from 'components/helpers/CustomFieldRenderers/SingleSelectRadioWithConditional.tsx/SingleMultiSelectFieldRenderer';
import React from 'react';


interface SurveyImportFormProps {
  actions: any[];
  programmes: any[];
  surveyTemplates: any[];
}

const SurveyImportForm: React.FC<SurveyImportFormProps> = () => {
  return (
    <div className="FormBox FormSideBySide">
      <EditSingleSelectRadio
        name={"action"}
        label={"Action"}
        dataSource={"actions"}
        editDisable={false}
      />
      <MultiSelectSearchListWithLinks
        name={"programmesId"}
        key={"programmesId"}
        label={"Programme"}
        dataSource={"programmes"}
        singleSelect={true}
      />
      <br />
      <MultiSelectSearchListWithLinks
        name={"surveyTemplatesId"}
        key={"surveyTemplatesId"}
        label={"Template"}
        dataSource={"surveyTemplates"}
        singleSelect={true}
      />
    </div>
  );
};

export default SurveyImportForm;